var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMIconNavProductGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7676 3.94467L13.8514 2.42353C13.6614 2.10555 13.4021 1.67076 13.0202 1.55019L8.72001 0.190221C7.91821 -0.0634071 7.07079 -0.0634071 6.26899 0.190221L1.96876 1.55082C1.6063 1.66576 1.2982 1.90815 1.09134 2.25298L0.235798 3.92093C-0.0223034 4.34885 -0.0710489 4.86298 0.10206 5.33151C0.274544 5.80003 0.64576 6.15986 1.12009 6.31729L1.25133 6.36101L1.24758 11.1112C1.24695 12.3238 2.01938 13.397 3.17053 13.78L6.20899 14.7926C6.62333 14.9307 7.05829 15 7.49388 15C7.92946 15 8.36442 14.9313 8.77876 14.7926L11.8197 13.7793C12.9709 13.3958 13.7458 12.325 13.7464 11.1144V6.35789L13.8952 6.30854C14.3632 6.15236 14.7288 5.79816 14.8994 5.33588C15.07 4.8736 15.0219 4.36697 14.7676 3.94467ZM0.688256 5.11536C0.581391 4.8255 0.611388 4.50753 0.781372 4.22454L1.63692 2.55596C1.67816 2.48725 1.72816 2.42478 1.78503 2.3698L7.03954 4.12646L5.80591 6.39975C5.56405 6.80268 5.08347 6.98009 4.63851 6.83141L1.3182 5.72507C1.0251 5.62699 0.795121 5.40522 0.688256 5.11536ZM7.17703 14.3609C6.9158 14.3372 6.65645 14.2835 6.40648 14.2004L3.36801 13.1877C2.47247 12.8891 1.87127 12.0552 1.8719 11.1119L1.87502 6.56904L4.43916 7.42363C5.16659 7.66601 5.94714 7.37678 6.34711 6.70897L7.18015 5.17408L7.17578 14.3603L7.17703 14.3609ZM2.63433 1.99498L6.45772 0.785561C7.13578 0.571289 7.85322 0.571289 8.5319 0.785561L12.3659 1.99873L7.50012 3.6217L2.63433 1.99498ZM13.1215 11.1144C13.1209 12.0558 12.5184 12.8885 11.6222 13.1871L8.58127 14.2004C8.3288 14.2847 8.06695 14.3384 7.8026 14.3616L7.80697 5.17096L8.64814 6.72084C8.94812 7.22123 9.47494 7.50796 10.0305 7.50796C10.2024 7.50796 10.3774 7.48048 10.5492 7.42301L13.1221 6.56592V11.1137L13.1215 11.1144ZM14.3132 5.11973C14.2089 5.40335 13.9845 5.62074 13.6977 5.71632L10.3511 6.83141C9.9049 6.97822 9.42557 6.80268 9.19059 6.41162L7.95196 4.12896L13.1021 2.41103C13.1865 2.52848 13.264 2.65841 13.3152 2.744L14.2326 4.26702C14.3889 4.52627 14.4182 4.83612 14.3132 5.11973Z",
    fill: "url(#paint0_radial_671_83640)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_671_83640",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7083 3.52041) rotate(-32.1344) scale(32.2291 17.1939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIconNavProductGradient);
export default __webpack_public_path__ + "static/media/m-icon-nav-product-gradient.21cdd2708efdc5cd648e8305a4adcea6.svg";
export { ForwardRef as ReactComponent };